import { useState } from "react";
import { motion } from "framer-motion";
import { Download, X, Loader2 } from "lucide-react";
import api, { mediaUrl } from "@/lib/api";

export function LeadModal({ photo, eventId, onClose }) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [busy, setBusy] = useState(false);
  if (!photo) return null;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/public/leads", { event_id: eventId, photo_id: photo.id, name: name.trim(), phone: phone.trim() });
    } catch { /* still allow download */ }
    const a = document.createElement("a");
    a.href = mediaUrl(photo.url);
    a.download = photo.original_filename || "pmr-photo.jpg";
    a.target = "_blank";
    a.click();
    setBusy(false);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center p-4 bg-maroon-dark/50 backdrop-blur-sm" data-testid="lead-modal">
      <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="bg-cream rounded-2xl p-7 max-w-sm w-full border border-maroon/15 shadow-2xl relative">
        <button onClick={onClose} className="absolute top-4 right-4 text-ink/40 hover:text-ink"><X className="w-5 h-5" /></button>
        <div className="w-11 h-11 rounded-full bg-maroon/10 flex items-center justify-center mb-3"><Download className="w-5 h-5 text-maroon" /></div>
        <h3 className="font-serif text-2xl text-ink">Almost there!</h3>
        <p className="text-sm text-ink/60 mt-1">Please share your details to download this photo.</p>
        <form onSubmit={submit} className="mt-5 space-y-3">
          <input data-testid="lead-name" required value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name"
            className="w-full bg-white border border-maroon/15 rounded-xl px-4 py-3 text-ink text-sm outline-none focus:border-gold" />
          <input data-testid="lead-phone" required value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone number" type="tel"
            className="w-full bg-white border border-maroon/15 rounded-xl px-4 py-3 text-ink text-sm outline-none focus:border-gold" />
          <button data-testid="lead-submit" disabled={busy} className="w-full flex items-center justify-center gap-2 bg-maroon text-cream rounded-xl py-3 font-medium hover:bg-maroon-dark disabled:opacity-60">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />} Download photo
          </button>
        </form>
      </motion.div>
    </div>
  );
}
